import ApiService from "../ApiService";

const incomeGroupService = {
  getAll() {
    return ApiService.get(`/income-group`);
  }
};

export default incomeGroupService;
